<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Edition d'un commentaire</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <quill-editor
                [(ngModel)]="comment"
                [modules]="editorModules"
                theme="snow"
                [placeholder]="'Écrire un commentaire...'"
                class="comment-editor"
                [customOptions]="customOptions"></quill-editor>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="save()" [disabled]="comment === ''">Enregistrer</button>
    </mat-card-actions>
</mat-card>
